import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import 'media-chrome';
import 'youtube-video-element';

@Component({
    selector: 'app-media-chrome-player',
    imports: [],
    templateUrl: './media-chrome-player.component.html',
    styleUrl: './media-chrome-player.component.scss',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MediaChromePlayerComponent {
    @ViewChild('mediaEl', { static: false }) mediaElRef!: ElementRef<any>;
    @Input({ required: true }) src: string = '';
    @Input() loop: boolean = true;
    @Input() controls: boolean = false;
    @Input() muted: boolean = true;
    @Input() autoplay: boolean = true;
    @Input() title: string = '';
    @Input() type: 'youtube' | 'video' = 'video';

    @Output() ended_event = new EventEmitter<void>();

    public state: 'play' | 'paused' = 'paused';

    constructor() { }

    playState(event: 'play' | 'paused') {
        this.state = event;
    }

    onEnded(): void {
        this.ended_event.emit();
    }
}
